var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"dnpk9qgyga","d":"M0 0L9.286 0 9.286 7.057 0 7.057z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("circle",{"cx":"13.5","cy":"13.5","r":"13.5","fill":"#292F3B","key":0}),React.createElement("g",{"opacity":".7","transform":"rotate(90 3.957 12.071)","key":1},React.createElement("path",{"fill":"#FFF","d":"M5.386 7.057c-.197 0-.393-.079-.543-.237l-.029-.034L.114.854C-.058.634-.031.306.176.122c.208-.185.517-.156.691.064l4.52 5.705L9.906.186c.174-.22.483-.249.69-.064.208.184.235.512.06.732l-4.713 5.95-.015.016c-.15.158-.346.237-.542.237"}))])]);
}

Menu.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27"};

module.exports = Menu;

Menu.default = Menu;
